/*
 * Ankway header - the behaviour the ported Sense markup expects:
 * the mobile menu drawer, the search modal and the sticky-header classes.
 */
(function () {
  'use strict';

  var SCOPE = '.ankway-header';

  /* Note: --viewport-height / --header-bottom-position are deliberately left
     unset. The live site never sets them either, and the drawer's own
     `calc(100vh - 100%)` fallback is what produces its real height. */

  /* ---------------------------------------------------------------- helpers */
  function lockScroll(on) {
    document.body.classList.toggle('overflow-hidden', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  /* Sense animates the panel in, so `menu-opening` lands one frame after
     `open`, and on close it comes off before `open` does. */
  function openDetails(details, summary) {
    details.setAttribute('open', '');
    // Force a reflow so the panel transitions in from its closed position.
    // (A rAF would do too, but it never fires while the tab is hidden.)
    void details.offsetWidth;
    details.classList.add('menu-opening');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetails(details, summary) {
    details.classList.remove('menu-opening');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    var panel = details.querySelector('.menu-drawer, .modal__content, .search-modal');
    var done = function () {
      details.removeAttribute('open');
    };
    if (panel) {
      var ms = parseFloat(getComputedStyle(panel).transitionDuration) * 1000;
      if (ms > 0) {
        window.setTimeout(done, ms);
        return;
      }
    }
    done();
  }

  function isOpen(details) {
    return details.hasAttribute('open') && details.classList.contains('menu-opening');
  }

  /* ------------------------------------------------------------ menu drawer */
  function initDrawer(root) {
    root.querySelectorAll('header-drawer > details').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen(details)) {
          closeDetails(details, summary);
          lockScroll(false);
        } else {
          openDetails(details, summary);
          lockScroll(true);
        }
      });

      // The ::before pseudo-element on summary is the click-catcher overlay.
      details.addEventListener('click', function (e) {
        if (e.target === summary || summary.contains(e.target)) return;
        var inner = details.querySelector('.menu-drawer__inner-container');
        if (inner && !inner.contains(e.target)) {
          closeDetails(details, summary);
          lockScroll(false);
        }
      });

      // Submenus inside the drawer.
      details.querySelectorAll('.menu-drawer__submenu').forEach(function (sub) {
        var d = sub.closest('details');
        var s = d && d.querySelector('summary');
        if (!d || !s || d === details) return;
        s.addEventListener('click', function (e) {
          e.preventDefault();
          if (isOpen(d)) closeDetails(d, s);
          else openDetails(d, s);
        });
      });

      details.querySelectorAll('.menu-drawer__close-button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = btn.closest('details');
          closeDetails(d, d.querySelector('summary'));
        });
      });
    });
  }

  /* ----------------------------------------------------------- search modal */
  function initSearch(root) {
    root.querySelectorAll('details-modal').forEach(function (modal) {
      var details = modal.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');
      var input = details.querySelector('input[type="search"], .search__input');

      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (isOpen(details)) {
            closeDetails(details, summary);
            lockScroll(false);
          } else {
            openDetails(details, summary);
            lockScroll(true);
            if (input) window.setTimeout(function () { input.focus(); }, 100);
          }
        });
      }

      details.querySelectorAll('.modal-overlay, .modal__close-button, .search-modal__close-button')
        .forEach(function (el) {
          el.addEventListener('click', function () {
            closeDetails(details, summary);
            lockScroll(false);
          });
        });

      // Clear button next to the search field.
      var reset = details.querySelector('.reset__button');
      if (reset && input) {
        var sync = function () {
          reset.classList.toggle('hidden', !input.value);
        };
        input.addEventListener('input', sync);
        reset.addEventListener('click', function (e) {
          e.preventDefault();
          input.value = '';
          sync();
          input.focus();
        });
        sync();
      }
    });
  }

  /* ------------------------------------------------------------- escape key */
  function initEscape(root) {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      root.querySelectorAll('details[open]').forEach(function (d) {
        var s = d.querySelector('summary');
        closeDetails(d, s);
        lockScroll(false);
        if (s) s.focus();
      });
    });
  }

  /* ---------------------------------------------------------- sticky header
     The section is already position:sticky in CSS; these classes only drive
     the shadow/hide-on-scroll-down treatment. */
  function initSticky(section, header) {
    if (!section) return;
    var last = window.scrollY;
    var onScroll = function () {
      var y = window.scrollY;
      section.classList.toggle('shopify-section-header-sticky', y > 0);
      var menuOpen = section.querySelector('details[open]');
      if (!menuOpen) {
        section.classList.toggle(
          'shopify-section-header-hidden',
          y > last && y > (header ? header.offsetHeight : 80)
        );
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------------- start */
  function init() {
    document.querySelectorAll(SCOPE).forEach(function (root) {
      if (root.dataset.ankwayReady) return;
      root.dataset.ankwayReady = '1';

      var header = root.querySelector('.header');
      var section = root.closest('.shopify-section') || root.parentElement;

      initDrawer(root);
      initSearch(root);
      initEscape(root);
      initSticky(section, header);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
